// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2UU8o","notes":"Notes_notes__2JcFb"};